<template>
	<div class="list">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              ref="my_scroller"

    >
      <van-cell-group inset v-for="(item, index) of list" :key="index">
        <van-cell :title="'会员姓名：' + item.name" :value="item.createtime" />
        <van-cell>
          <template #title>
            <p>{{item.orderno}}</p>
            <div class="product">
              <div class="bestSellingSwiper" style="overflow: hidden;position:relative;">
                <swiper :options="swiperOption" ref="mySwiper">
                  <swiper-slide v-for="(goodsitem, goodsindex) of item.itemlist" :key="goodsindex">
                    <div class="img">
                      <img :src="goodsitem.img_path">
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <span class="totalPrice totalPriceShadow">
                <span class="price">
                  ￥{{item.ordermoney}}
                </span>
                <b>共{{item.item_nums}}件</b>
              </span>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </Scroller>
  </div>
</template>

<script>
	import {isWeixin, fenxiang} from '../../assets/common/js/config'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import Vue from 'vue'
import Scroller from '../common/Scroller'
Vue.use(VueAwesomeSwiper /* { default global options } */)
export default {
  name: "vipgiftbagdata",
  data () {
    return {
      list: [],
      refresh: false,
      loading: false,
      finished: false,
	  noDataText: '',
      nowPage: 0,
      swiperOption: {
        autoplay: false,
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        observer: true,
        observeParents: true,
        spaceBetween: 10
      },
    }
  },
  components: {
    Scroller
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    if (!sessionStorage.askPositon || from.path == '/') { // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next(vm => {
        Object.assign(vm.$data, vm.$options.data());
	      if (isWeixin()) {
		      fenxiang({path: 'vipgiftbagdata'})
	      }
      })
    } else {
      next(vm => {
        if (from.path == '/') {
          Object.assign(vm.$data, vm.$options.data());
        }
	      if (isWeixin()) {
		      fenxiang({path: 'vipgiftbagdata'})
	      }
        if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
          setTimeout(function () {
            window.scrollTo(0, sessionStorage.askPositon, false)
          }, 0) // 同步转异步操作
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    getData () {
      var that = this, url = 'Wxmall/VipGift/getMeetOrderList?pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&loginmobile=' + (sessionStorage.getItem('meetinglogin_mobile') ? sessionStorage.getItem('meetinglogin_mobile') : '')
      this.$customRequestAjax(url).then(res => {
        if (res.data.code == 200) {
          if (that.nowPage === 1) {
            that.list = res.data.list
			if (res.data.list.length > 0) {
			  that.noDataText = '暂无数据~'
			} else {
			  that.noDataText = ''
			}
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.list)
          }
          that.loading = false
          if (res.data.list.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/common/css/createmeeting";
  .van-cell__title {
    max-width: 100%;
  }
  .van-cell-group--inset {
    margin-top: 0.1rem;
    padding: 0.05rem 0;
  }
  .product {
    margin-top: 0.08rem;
    position: relative;
    width: 100%;
    .bestSellingSwiper {
      /*padding-right: 0.6rem;*/
      width: 100%;
      .swiper-container {
        padding-right: 0.6rem;
        .swiper-wrapper {
          >.swiper-slide {
            width: 0.8rem;
            position: relative;
            background-color: white;
            .img {
              width: 0.8rem;
              height: 0.8rem;
              position: relative;
              .tag{
                position: absolute;
                right: 0;
                top:0;
                font-size: .12rem;
                .van-tag{
                  border-radius:0px 0px 0px 2px;
                }
              }
              img {
                &:first-of-type {
                  width: 100%;
                  height: 100%;
                }
                &.zeng {
                  position: absolute;
                  right: 0;
                  top: 0;
                  width: 0.23rem;
                  height: 0.23rem;
                  &.group {
                    width: 0.24rem;
                    height: 0.15rem;
                  }
                }
                &.add{
                  position: absolute;
                  right: 0;
                  top: 0;
                  width: 0.23rem;
                  height: 0.23rem;
                }
                &.both{
                  width: 0.26rem;
                  height: 0.13rem;
                }
              }
            }
          }
        }
      }
    }
    .totalPrice {
      position: absolute;
      right: -0.02rem;
      top: 0;
      z-index: 10;
      opacity:0.85;
      height: 0.8rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &.totalPriceShadow {
        background: linear-gradient(to right, rgba(255, 255, 255, .5), rgba(255, 255, 255, .9), rgba(255, 255, 255, 1));
      }
      &+.totalPriceNoShadow {
        background:rgba(255,255,255,1);
      }
      .price {
        display: flex;
        align-items: flex-end;
        font-size: 0.14rem;
        font-weight:normal;
        text-align: right;
        color:#222222;
        line-height:0.14rem;
      }
      >b {
        color: #908D8D;
        font-size: 0.11rem;
        line-height: 0.16rem;
        display: block;
        font-weight:400;
        text-align: right;
        white-space: nowrap;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/createmeeting/vipgiftbagdata.vue